import { render } from "./VideoPlayerWrapper.vue?vue&type=template&id=3fdc6b8f&scoped=true"
import script from "./VideoPlayerWrapper.vue?vue&type=script&lang=js"
export * from "./VideoPlayerWrapper.vue?vue&type=script&lang=js"

import "./VideoPlayerWrapper.vue?vue&type=style&index=0&id=3fdc6b8f&scoped=true&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdc6b8f"]])

export default __exports__